export function redactStripeClientSecrets(value) {
  if (typeof value !== "string") return value;
  return value
    .replace(
      /((?:setup_intent|payment_intent)_client_secret(?:=|%3d))[^&\s"'<>#]*/gi,
      "$1[redacted]",
    )
    .replace(/(?:seti|pi)_[A-Za-z0-9]+_secret_[A-Za-z0-9]+/g, "[redacted]");
}
